import BotConditionPicker from 'components/BotConditionPicker/BotConditionPicker';
import PageContainer from 'components/PageContainer/PageContainer';
import PageContent from 'components/PageContent/PageContent';
import { PageHeadLine } from 'components/PageHeadLine/PageHeadLine';
import PrimaryButton from 'components/PrimaryButton/PrimaryButton';
import { inject, observer } from 'mobx-react';
import { ConditionChild } from 'models/Bot';
import { ModalStore } from 'stores/private/ModalStore';
import { ProjectStore } from 'stores/private/ProjectStore';

interface ConditionActionEditorProps {
  condition: ConditionChild;
  projectStore?: ProjectStore;
  modalStore?: ModalStore;
}

const ConditionActionEditor = ({
  condition,
  projectStore,
  modalStore,
}: ConditionActionEditorProps) => {
  return (
    <div className="input-action-editor">
      <PageContainer>
        <PageHeadLine title="Edit condition">
          <div className="header-content-right">
            <PrimaryButton
              label="Save"
              icon="circle-check"
              iconSideRight={false}
              onClick={() => {
                modalStore!.closeModal();
              }}
            />
          </div>
        </PageHeadLine>
        <PageContent hasTitle>
          <BotConditionPicker predicate={condition.predicates} />
        </PageContent>
      </PageContainer>
    </div>
  );
};

export default inject(
  'projectStore',
  'modalStore',
)(observer(ConditionActionEditor));
